"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateAnimation = exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const faSpinnerThird_1 = require("@fortawesome/pro-solid-svg-icons/faSpinnerThird");
const icons_1 = require("../../atoms/icons");
const Spinner = ({ className }) => ((0, jsx_runtime_1.jsx)(Wrapper, { className: className, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faSpinnerThird_1.faSpinnerThird }, void 0) }, void 0));
exports.Spinner = Spinner;
exports.rotateAnimation = (0, styled_components_1.keyframes) `
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Wrapper = styled_components_1.default.div `
  & > div {
    animation: ${exports.rotateAnimation} 1s infinite;
    color: ${({ theme }) => theme.colors.greenBase};
  }
`;
//# sourceMappingURL=Spinner.js.map